import "./BYEHygieneMistHome.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Origin from "./sections/Origin";
import Collections from "./sections/Collections";
import Mist from "./sections/Mist";
import Featured from "./sections/Featured";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function BYEHygieneMistHomePage() {
  return <div>
      <Header />
      <Hero />
      <Origin />
      <Collections />
      <Mist />
      <Featured />
      <Faq />
      <Footer />
    </div>;
}